import { render, staticRenderFns } from "./ZurueckButton.vue?vue&type=template&id=44743cea&scoped=true&"
import script from "./ZurueckButton.vue?vue&type=script&lang=js&"
export * from "./ZurueckButton.vue?vue&type=script&lang=js&"
import style0 from "./ZurueckButton.vue?vue&type=style&index=0&id=44743cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44743cea",
  null
  
)

component.options.__file = "ZurueckButton.vue"
export default component.exports